export function formatOrganizationCode(code: string) {
  return code.replace(/[^a-zA-Z0-9_-]/g, '').toLowerCase();
}
